export default __webpack_public_path__ + "static/media/sec1-bg2.3763d05b.jpg";